
import React, { useState } from "react"
import  "./Loading.css";

const Loading=()=>{
    
    return(
        <React.Fragment>
           <div className="w-100">
      <div className="loader-container">
 
         <div className="spinner"></div>
      </div>

      
    </div>
            </React.Fragment>
        )
}
export default Loading;





